import React, { useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { IOSSwitch } from "../../../../components/redesign-components/IOSSwitch/IOSSwitch";

export const PlanCard = ({
  textList,
  type,
  header,
  subText,
  plan,
  purchaseble = false,
  currentPlan,
  onGetStarted,
  addonDetails = { show: false, state: false, onChange: () => "" },
  isMonthly,
}) => {
  const isHeaderString = typeof header === "string";
  const priceLabel = !isHeaderString
    ? isMonthly
      ? `$${header.monthlyTotal}/mo`
      : `$${header.annualTotal}/year`
    : header;

  return (
    <div className="lg:min-w-[300px] w-full flex flex-col justify-between gap-2 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
      <div className="flex flex-col items-center p-6 lg:p-8">
        <div className="text-primary700 text-2xl font-semibold">{type}</div>

        {/* main price / header */}
        <div className="text-gray900 text-lg font-semibold mt-2">
          {priceLabel}
        </div>

        {/* annual-only savings row */}
        {!isHeaderString && !isMonthly && header?.savings && (
          <div className="flex flex-wrap items-center gap-2 mt-2">
            <span className="text-gray600 text-base font-medium">
              $
              {(
                Math.floor(header.savings.effectiveMonthly * 100) / 100
              ).toFixed(2)}
              /mo
            </span>
            <span className="text-success700 text-xs font-semibold bg-success50 px-2 py-0.5 rounded-full">
              Save {header.savings.savingsPercent}%
            </span>
          </div>
        )}

        <div className="text-gray700 text-base mt-2">{subText}</div>

        {/*         
        {addonDetails.show && !plan.includes(currentPlan) && (
          <div className="w-full rounded-xl border-[1.5px] border-primary700 p-2 mt-3">
            <div className="rounded-xl border-[1.5px] border-primary700 px-2 w-fit">
              <div className="text-sm font-semibold text-primary600">
                Add-on
              </div>
            </div>
            <div className="mt-3 flex items-center gap-4">
              <div className="text-sm font-semibold text-gray700">
                Foresight Integration for $400
              </div>
              <IOSSwitch
                checked={addonDetails.state}
                onChange={addonDetails.onChange}
              />
            </div>
          </div>
        )} */}

        <ul className="w-full mt-4 flex flex-col gap-2">
          {textList.map((feature) => {
            return (
              <li className="flex items-start gap-2" key={feature}>
                <div className="flex size-5 min-w-5 items-center justify-center rounded-full bg-primary100 p-0.5 md:size-6 md:min-w-6">
                  <IoMdCheckmark className="size-full text-primary500" />
                </div>
                <span className="text-base text-gray600">{feature}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="bg-gray50 min-h-[112px] p-8 flex justify-center items-center">
        {plan.includes(currentPlan) ? (
          <div className="flex items-center gap-2">
            <IoMdCheckmark className="size-4 min-w-4 text-success700" />
            <div className="text-success700 font-semibold text-base">
              Current plan
            </div>
          </div>
        ) : purchaseble ? (
          <button
            onClick={onGetStarted}
            className="w-full min-h-11 h-11 rounded-full font-semibold text-base btnPrimary500"
          >
            Get started
          </button>
        ) : (
          <button
            onClick={() => window.open("mailto:sales@sportsbox.ai", "_blank")}
            className="w-full min-h-11 h-11 rounded-full font-semibold text-base btnPrimary700Outlined"
          >
            Let's chat
          </button>
        )}
      </div>
    </div>
  );
};
